import React, { useState, useEffect } from 'react';
import { Flex, Box, Center, Spinner, useToast } from '@chakra-ui/react';
import useHttp from '../utils/http';
import { Stat } from '../components/dashboard/Stat';
import { TopTable } from '../components/dashboard/TopTable';
import { TopTablePercent } from '../components/dashboard/TopTablePercent';
import BarGraph from '../components/dashboard/BarGraph';
// import { set } from 'date-fns';

const Dashboard = () => {
    const [stats, setStats] = useState({});
    //const [loading, setLoading] = useState(true);
    //const [noData, setNoData] = useState(true);
    const { get } = useHttp();
    const toast = useToast();

    function isEmptyObject(data) {
        return (
            typeof data === 'object' &&
            data !== null &&
            Object.keys(data).length === 0
        );
    }

    useEffect(() => {
        const getStats = async () => {
            try {
                // Calculate the local time offset and DST flag
                const timezoneOffset = new Date().getTimezoneOffset(); // in minutes
                const isDST = (new Date()).getTimezoneOffset() !== (new Date(Date.UTC(new Date().getFullYear(), 0, 1))).getTimezoneOffset();

                // Create a query string with the timezoneOffset and isDST
                const queryParams = new URLSearchParams({
                    localtimeOffset: -timezoneOffset, // Negate to match server expectation
                    isDST: isDST ? '1' : '0' // Convert boolean to string
                });

                const response = await get(`api/reports/dashboard?${queryParams.toString()}`);

                const { data } = response;
                if (isEmptyObject(data)) {
                    return;
                }

                if (data.orders.number === 0) {
                    return;
                }

                const tempStats = [
                    {
                        label: 'Total de Ordenes',
                        value: data.orders.number,
                        since: data.orders.since,
                        color: "gray.500"
                    },
                    {
                        label: 'Minutos Promedio por Orden',
                        value: (data?.averageTime)?.toFixed(2),
                        color: "red"
                    },
                    {
                        label: 'Productos Promedio por orden',
                        value: (data?.productsPerOperation)?.toFixed(2),
                        color: "blue"
                    },
                    {
                        label: 'Promedio de días en almacén',
                        value: data?.averageDaysInWarehouse,
                        color: "green"
                    }
                ];
                setStats({ kpis: tempStats, ...data });

            } catch (error) {
                toast({
                    title: 'Error al obtener reportes',
                    description: error.message,
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                });
            }
        };

        getStats();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (
        !stats.kpis ||
        (stats.kpis.length === 0 &&
            !stats.orders?.number &&
            !stats.averageTime &&
            !stats.productsPerOperation &&
            !stats.averageDaysInWarehouse &&
            stats.topSKU.length === 0 &&
            stats.topCustomers.length === 0 &&
            stats.topOperators.length === 0 &&
            Object.keys(stats.locationPercentages).length === 0 &&
            Object.keys(stats.operationTypePercentages).length === 0 &&
            stats.operationsPerDay.length === 0)
    ) {
        return (
            <Center height="100vh" width="100%">
                <Spinner size="xl" thickness="6px" speed="0.65s" emptyColor="gray.200" color="blue.500" width="150px" height="150px" />
            </Center>
        );
    }

    return (
        <Flex wrap="wrap" justifyContent="space-between" mt='2%'>
            {Array.isArray(stats.kpis) && stats.kpis.map((stat, id) => (
                <Box key={id} w={{ base: "100%", md: "50%", lg: '24%' }} p={4}>
                    <Stat {...stat} />
                </Box>
            ))}
            <TopTable w={{ base: "100%", md: "40%", lg: "18%" }} p={4} m={4} title="Top 5 SKUs"
                data={stats.topSKU} />
            <TopTable w={{ base: "100%", md: "40%", lg: "15%" }} p={4} m={4} title="Top 5 Clientes"
                data={stats.topCustomers} />
            <TopTable w={{ base: "100%", md: "40%", lg: "15%" }} p={4} m={4} title="Top 5 Operadores"
                data={stats.topOperators} />
            <TopTablePercent w={{ base: "100%", md: "40%", lg: "22%" }} p={4} m={4} title="Top 5 Ubicaciones"
                data={stats.locationPercentages} />
            <TopTablePercent w={{ base: "100%", md: "40%", lg: "18%" }} p={4} m={4} title="Top 5 Operaciones"
                data={stats.operationTypePercentages} />
            {Array.isArray(stats.operationsPerDay) && <BarGraph m={4} data={stats.operationsPerDay} />}
        </Flex>
    );
};

export default Dashboard;
